import type { HomePage } from '../model/HomePage';

export const CitizenDev: HomePage = {
    name: 'CitizenDev',
    widgets: [ 'RecommendationTemplates', 'Apps', 'Automations', 'Runs', 'Actions' ],
    featureFlag: 'HomePage-CitizenDev',
    persona: 'CITIZEN_DEV',
};
